// removed by extract-text-webpack-plugin
module.exports = {"closeButton":"close-button-module__closeButton___1grXV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/close-button/close-button.module.scss
// module id = 774
// module chunks = 0